import {
    EVENTS_DEVICES_REQUEST,
    EVENTS_DEVICES_SUCCESS,
    EVENTS_DEVICES_FAILURE,
    EVENTS_DATA_REQUEST,
    EVENTS_DATA_SUCCESS,
    EVENTS_DATA_FAILURE,
    EVENTS_FILTER_APPLY,
    EVENTS_RESET
} from "./ActionTypes";

const createInitialState = () => ({
    devices: {
        items: [],
        loading: false,
        error: null,
        requestId: null,
        objectId: null
    },

    data: {
        items: [],
        loading: false,
        error: null,
        failedDeviceIds: [],
        requestId: null
    },

    /*
     * Детализации у событий нет, поэтому в применённом
     * фильтре только период и выбранные устройства.
     */
    appliedFilter: {
        dateFrom: null,
        dateTo: null,
        selectedDeviceIds: []
    },

    hasAppliedFilter: false
});

const initialState = createInitialState();

const EventsReducer = (state = initialState, action) => {
    switch (action.type) {
        case EVENTS_DEVICES_REQUEST:
            return {
                ...state,

                devices: {
                    items: [],
                    loading: true,
                    error: null,
                    requestId: action.requestId,
                    objectId: action.objectId
                }
            };

        case EVENTS_DEVICES_SUCCESS:
            // Не принимаем результат устаревшего запроса.
            if (
                state.devices.requestId !== action.requestId
            ) {
                return state;
            }

            return {
                ...state,

                devices: {
                    items: action.items || [],
                    loading: false,
                    error: null,
                    requestId: action.requestId,
                    objectId: state.devices.objectId
                }
            };

        case EVENTS_DEVICES_FAILURE:
            if (
                state.devices.requestId !== action.requestId
            ) {
                return state;
            }

            return {
                ...state,

                devices: {
                    items: [],
                    loading: false,

                    error:
                        action.error ||
                        "Не удалось загрузить устройства",

                    requestId: action.requestId,
                    objectId: state.devices.objectId
                }
            };

        case EVENTS_FILTER_APPLY:
            return {
                ...state,

                appliedFilter: {
                    ...state.appliedFilter,
                    ...action.filter,

                    selectedDeviceIds:
                        action.filter &&
                        action.filter.selectedDeviceIds
                            ? [
                                ...action.filter
                                    .selectedDeviceIds
                            ]
                            : []
                },

                hasAppliedFilter: true
            };

        case EVENTS_DATA_REQUEST:
            return {
                ...state,

                data: {
                    items: [],
                    loading: true,
                    error: null,
                    failedDeviceIds: [],
                    requestId: action.requestId
                }
            };

        case EVENTS_DATA_SUCCESS:
            // Пользователь мог применить новый фильтр,
            // пока предыдущий запрос ещё выполнялся.
            if (state.data.requestId !== action.requestId) {
                return state;
            }

            return {
                ...state,

                data: {
                    items: action.items || [],
                    loading: false,
                    error: null,

                    failedDeviceIds:
                        action.failedDeviceIds || [],

                    requestId: action.requestId
                }
            };

        case EVENTS_DATA_FAILURE:
            if (state.data.requestId !== action.requestId) {
                return state;
            }

            return {
                ...state,

                data: {
                    items: [],
                    loading: false,

                    error:
                        action.error ||
                        "Не удалось загрузить события",

                    failedDeviceIds:
                        action.failedDeviceIds || [],

                    requestId: action.requestId
                }
            };

        case EVENTS_RESET:
            return createInitialState();

        default:
            return state;
    }
};

export default EventsReducer;
